import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.714 19.285A10.001 10.001 0 1 1 6.286.713a10.001 10.001 0 0 1 7.428 18.572M8.784 6.27a2 2 0 0 1 1.354-.248h-.001A2 2 0 0 1 11.8 7.997V8c0 .468-.365.958-1.055 1.418a6.2 6.2 0 0 1-1.247.628l-.015.006H9.48a1 1 0 0 0 .637 1.895h.005l.01-.005.035-.012c.593-.216 1.16-.5 1.686-.849.81-.54 1.945-1.55 1.945-3.08a4 4 0 0 0-7.773-1.33 1 1 0 0 0 1.886.662c.156-.446.465-.823.873-1.063m1.024 4.756.31.921s-.002 0-.31-.92m-.637 3.266A1 1 0 0 0 9.878 16h.01a1 1 0 0 0 0-2h-.01a1 1 0 0 0-.707.292",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }